import { FormControlsModule } from './form-controls/form-controls.module';


export const Moduels = [
    FormControlsModule
]